﻿import { useEffect, useState, useRef } from "react";
import { Row, Col } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import classes from "./ordersSaleAction.module.scss";

import { getToday, hasPermission } from "@/services/Utils";

import ButtonFilter from "@/components/Filter/ButtonFilter";
import FormPrint from "@/pages/Inventory/Print/FormPrint";

import { FETCHING_ADD_DOWNLOAD } from "@/redux/types/main.types";
import { CHANGE_TAGS_AVAILABLE } from "@/redux/types/inventory.types";
import { useOrderSalePaginate } from "@/hooks/purchases/orders_sale";

const OrdersSaleAction = ({ showFilter, setShowFilter, filters, setIntegrationSelect }) => {
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const location = useLocation();

	let mounted = useRef(null);

	const { data } = useOrderSalePaginate(filters);
	const { permissions, integrations } = data ? data : {};

	const { filter } = useSelector((state) => state.auth);
	const { tags_available, lots_available } = useSelector((state) => state.inventory);

	const [showPrint, setShowPrint] = useState(false);
	const [typePrint, setTypePrint] = useState("new");

	const exportExcel = () => {
		const filename = `${location.pathname.replace("/", "")}  ${getToday()}.xlsx`;

		const params = {
			...filters,
			...filter,
		};

		dispatch({
			type: FETCHING_ADD_DOWNLOAD,
			payload: {
				file: {
					key: Array.from({ length: 25 }, () => Math.random().toString(36)[2] || "0").join(""),
					params: params,
					show: true,
					url: "/client/excel/facturas",
					name: filename,
					type: "excel",
					inExecution: false,
					inProgress: false,
					inChecked: false,
				},
			},
		});
	};

	const handleClickFile = (_integration) => {
		if (mounted.current) {
			mounted.current.click();
		}
	};

	const handleFileChange = (e, integration) => {
		const file = e.target.files[0];
		if (file) {
			setIntegrationSelect({
				show: true,
				name: integration.name,
				integration: integration.slug,
				file: file,
			});
		}
	};

	useEffect(() => {
		const { tags_available, lots_available } = data ? data : {};

		dispatch({
			type: CHANGE_TAGS_AVAILABLE,
			payload: {
				tags_available: tags_available,
				lots_available: lots_available,
			},
		});

		// eslint-disable-next-line
	}, [data]);

	let countTags = 0;
	tags_available &&
		tags_available.forEach((tag) => {
			countTags += Number(tag.quantity_available);
		});

	return (
		<Row className={classes.header}>
			<ButtonFilter origin="actions" size_md={1} showFilter={showFilter} setShowFilter={setShowFilter} />

			<Col md={11} style={{ justifyContent: "right", display: "flex" }}>
				{integrations &&
					integrations.length > 0 &&
					integrations.map((integration, index) => {
						return (
							<div
								key={index}
								className={`${classes.optionButton}`}
								onClick={() => {
									integration.type === "EXCEL"
										? handleClickFile(integration.slug, integration.name, integration.type)
										: setIntegrationSelect({
												show: true,
												name: integration.name,
												integration: integration.slug,
											});
								}}
							>
								<span className={classes.spanIntegration}>Sincronizar</span>
								<img className={`${classes.imgIntegration} ${classes[integration.slug]}`} src={integration.logo} alt={integration.name} />

								<input
									ref={mounted}
									type="file"
									accept=".xlsx, .xls"
									style={{ display: "none" }}
									onChange={(e) => handleFileChange(e, integration)}
								/>
							</div>
						);
					})}

				{countTags !== 0 ? (
					<div
						className={`${classes.optionButton} ${classes.newInventory}`}
						onClick={() => {
							setTypePrint("new");
							setShowPrint(true);
						}}
					>
						<span>
							Etiqueta
							<span className={classes.floatNumber}>{countTags}</span>
						</span>
					</div>
				) : (
					""
				)}

				{lots_available && lots_available.length !== 0 ? (
					<div
						className={`${classes.optionButton} ${classes.newInventory}`}
						onClick={() => {
							setTypePrint("lots");
							setShowPrint(true);
						}}
					>
						<span>
							Lote
							<span className={classes.floatNumber}>{lots_available.length}</span>
						</span>
					</div>
				) : (
					""
				)}

				{hasPermission("create", permissions) && (
					<div
						className={`${classes.optionButton} ${classes.newInventory}`}
						onClick={() => {
							navigate(`${location.pathname}/ingresar`);
						}}
					>
						<span>Cargar</span>
					</div>
				)}

				<div className={`${classes.optionButton} ${classes.exportInventory}`} onClick={() => exportExcel()}>
					<span>Excel</span>
				</div>
			</Col>

			<FormPrint
				showPrint={showPrint}
				setShowPrint={setShowPrint}
				search={""}
				page={1}
				paginate={10}
				defaultUnit={filters.defaultUnitFilter}
				typePrint={typePrint}
			/>
		</Row>
	);
};

export default OrdersSaleAction;
